'use client';

type UmamiValue = string | number | boolean | null | undefined;
export type UmamiPayload = Record<string, UmamiValue>;

type UmamiTracker = {
  track: (eventName: string, payload?: UmamiPayload) => void;
};

/**
 * Safely track an Umami event without breaking rendering if the script is absent.
 */
export function trackEvent(eventName: string, payload?: UmamiPayload) {
  if (typeof window === 'undefined') return;

  try {
    const umami = (window as Window & { umami?: UmamiTracker }).umami;
    if (typeof umami?.track === 'function') {
      umami.track(eventName, payload);
    }
  } catch {
    // Swallow errors to avoid interrupting the UX if analytics fails
  }
}
